<template>
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 via-purple-50 to-pink-100 animate-gradient-x">
    <div v-loading="loading"
         class="bg-white/90 backdrop-blur-sm p-6 rounded-2xl shadow-2xl w-full max-w-md transform transition-all duration-300 hover:scale-105 hover:shadow-indigo-200">
      <!-- 左上角标志 -->
      <div class="mb-6 text-center transform transition-all duration-500 hover:scale-110">
        <img @click="tohome" alt="IP奇迹ip Logo" class="h-16 mx-auto cursor-pointer" src="@/assets/logB.png"/>
      </div>
      <h2 class="text-3xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-indigo-600 mb-6 text-center">
        注册账号
      </h2>
      <!-- 手机号输入框 -->
      <div class="mb-4">
        <div class="relative group">
          <i class="fas fa-phone absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 group-hover:text-indigo-500 transition-colors duration-200">
          </i>
          <input
              class="w-full pl-12 pr-4 py-2.5 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-all duration-200 bg-white/50 backdrop-blur-sm"
              type="tel"
              :maxlength="20"
              v-model.trim="form.phone"
              placeholder="请输入手机号"/>
        </div>
      </div>
      <!-- 邮箱输入框 -->
      <div class="mb-4">
        <div class="relative group">
          <i class="fas fa-envelope absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 group-hover:text-indigo-500 transition-colors duration-200">
          </i>
          <input
              class="w-full pl-12 pr-4 py-2.5 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-all duration-200 bg-white/50 backdrop-blur-sm"
              type="email"
              :maxlength="100"
              v-model.trim="form.email"
              placeholder="请输入邮箱"/>
        </div>
      </div>
      <!-- 用户名输入框 -->
      <div class="mb-4">
        <div class="relative group">
          <i class="fas fa-user absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 group-hover:text-indigo-500 transition-colors duration-200">
          </i>
          <input
              class="w-full pl-12 pr-4 py-2.5 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-all duration-200 bg-white/50 backdrop-blur-sm"
              type="text"
              :maxlength="20"
              v-model.trim="form.username"
              placeholder="请输入用户名"/>
        </div>
      </div>
      <!-- 密码输入框 -->
      <div class="mb-4">
        <div class="relative group">
          <i class="fas fa-lock absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 group-hover:text-indigo-500 transition-colors duration-200">
          </i>
          <input
              class="w-full pl-12 pr-4 py-2.5 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-all duration-200 bg-white/50 backdrop-blur-sm"
              type="password"
              :maxlength="50"
              v-model.trim="form.paswd"
              placeholder="请输入密码"/>
        </div>
      </div>
      <!-- 确认密码输入框 -->
      <div class="mb-4">
        <div class="relative group">
          <i class="fas fa-lock absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 group-hover:text-indigo-500 transition-colors duration-200">
          </i>
          <input
              class="w-full pl-12 pr-4 py-2.5 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-all duration-200 bg-white/50 backdrop-blur-sm"
              type="password"
              :maxlength="50"
              v-model.trim="form.paswd_again"
              placeholder="请再次输入密码"/>
        </div>
      </div>
      <!-- 复选框 -->
      <div class="mb-6 flex items-center justify-between">
        <div class="flex items-center group cursor-pointer">
          <input
              class="mr-2 w-4 h-4 text-indigo-600 border-2 border-gray-300 rounded focus:ring-indigo-500 focus:ring-offset-0 transition-all duration-200 cursor-pointer"
              type="checkbox"
              v-model="checked"
              id="agreeTerms"/>
          <label class="text-sm text-gray-600 group-hover:text-indigo-600 transition-colors duration-200 select-none cursor-pointer" for="agreeTerms">
            我已阅读并同意
            <a class="text-indigo-600 hover:text-indigo-800 font-medium border-b border-indigo-600 hover:border-indigo-800" href="javascript:void(0);">
              服务条款
            </a>
          </label>
        </div>
      </div>
      <!-- 注册按钮 -->
      <button
          class="w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-3 px-6 rounded-xl hover:from-indigo-700 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-indigo-300 shadow-lg transform transition-all duration-300 hover:scale-102 hover:shadow-indigo-200 font-semibold"
          @click="codeLogin('form')">
        <i class="fas fa-user-plus mr-2 animate-pulse">
        </i>
        立即注册
      </button>
      <!-- 登录链接 -->
      <div class="mt-6 text-center">
        <span class="text-gray-500">
         已有账号？
        </span>
        <a class="text-indigo-600 hover:text-indigo-800 font-medium ml-2 border-b border-indigo-600 hover:border-indigo-800 transition-colors duration-200"
           @click="tologin">
          立即登录
        </a>
      </div>
    </div>

  </div>
</template>

<script>
import api from "@/requset/api";

export default {
  name: 'UserRegistration',
  data() {
    return {
      loading: false,
      checked: "",
      valueL: "",
      radio: "1",
      datauser: {
        name: "",
        smsCode: "",
      },
      huakuai: "",
      show: true,
      count: 60,
      form: {
        email: "",
        phone: "",
        username: "",
        smsCode: "",
        checkMove: "",
        paswd: "",
        paswd_again: "",
      },
      codeRules: {
        email: [{required: true, message: "请输入邮箱", trigger: "blur"}],
        username: [{required: true, message: "请输入用户名", trigger: "blur"}],
        paswd: [{required: true, message: "请输入密码", trigger: "blur"}],
        paswd_again: [{required: true, message: "请再次输入密码", trigger: "blur"}],
        smsCode: [
          {required: true, message: "请输入手机验证码", trigger: "blur"},
        ],

        checkMove: [
          {required: true, message: "滑动完成验证", trigger: "blur"},
        ],
      },
    };
  },
  components: {},
  directives: {
    move(el, binding) {
      el.onmousedown = function (e) {
        var X = e.clientX - el.offsetLeft;
        document.onmousemove = function (e) {
          var endx = e.clientX - X;
          el.className = "move moveBefore";
          el.style.left = endx + "px";
          var width =
              document.querySelector(".movebox").offsetWidth -
              document.querySelector(".move").offsetWidth;
          el.parentNode.children[0].style.width = endx + "px";
          el.parentNode.children[1].innerHTML = "按住滑块,拖动到最右边";

          //临界值小于
          if (endx <= 0) {
            el.style.left = 0 + "px";
            el.parentNode.children[0].style.width = 0 + "px";
          }
          //临界值大于
          if (parseInt(el.style.left) >= width) {
            el.style.left = width + "px";
            el.parentNode.children[0].style.width = width + "px";
            el.parentNode.children[1].innerHTML =
                "<span style='color:#000'>验证通过</span>";
            el.className = "move moveSuccess";
            document.onmousemove = null;
            el.onmousedown = null;
            binding.value();
          }
        };
      };
      document.onmouseup = function () {
        document.onmousemove = null;
      };
    },
  },

  mounted() {
  },
  methods: {
    pull() {
      this.form.checkMove = true;
    },
    //发送短信验证码
    sendCode() {
      if (!this.form.phone) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
        });
        return;
      }
      if (!this.form.checkMove) {
        this.$message({
          message: "滑块验证有误，请重新验证",
          type: "warning",
        });
        return;
      }

      api.send_captcha({
        phone: this.form.phone,
      })
        .then((res) => {
          if (res.data.error_code === 0) {
            this.$message({
              message: "验证码已发送",
              type: "success"
            });

            this.show = false;
            let timeId = setInterval(() => {
              if (this.count <= 0) {
                this.show = true;
                clearInterval(timeId);
                this.count = 60;
              } else {
                this.count--;
              }
            }, 1000);
          } else {
            this.$message({
              message: res.data.message,
              type: "warning",
            });
          }
        })
        .catch(() => {
          this.$message({
            message: "发送验证码失败，请稍后重试",
            type: "error",
          });
        });
    },

    codeLogin() {
      console.log(this.form);
      if (this.checked) {
        if (this.form.paswd !== this.form.paswd_again) {
          this.$message({
            message: "2次验证码不一致",
            type: "warning",
          });
        } else if (this.form.username.length == 0) {
          this.$message({
            message: "必须输入用户名",
            type: "warning",
          });
        } else if (this.form.email.length == 0) {
          this.$message({
            message: "必须输入邮箱",
            type: "warning",
          });
        } else {
          this.loading = true
          api.register({
            phone: this.form.phone,
            email: this.form.email,
            captcha: this.form.smsCode,
            password: this.form.paswd,
            username: this.form.username,
          })
              .finally(() => {
                this.loading = false
              })
              .then((res) => {
                if (res.data.error_code == 0) {
                  this.$message({
                    message: "注册成功",
                    type: "success",
                  });
                  this.$router.push({path: "login"});
                } else {
                  this.$message({
                    message: res.data.message,
                    type: "warning",
                  });
                }
              })
              .catch((err) => {
                console.log(err, "失败");
              });
        }
      } else {
        this.$message({
          message: "请勾选《用户协议》",
          type: "warning",
        });
      }
    },
    tohome() {
      this.$router.push({path: "/"});
    },
    tologin() {
      this.$router.push({path: "login"});
    },
  },
};
</script>

